export default __webpack_public_path__ + "static/media/rocket_ship.b72b6ed3.jpg";